import React from 'react';
import PropTypes from 'prop-types';
import ValidatingForm from '../forms/validating_form';
import MinisterCheckbox from '../fields/minister_checkbox';

class Beliefs extends ValidatingForm {
  render() {
    return (
      <div>
        <form className='ordination-form'>
          <div className='ordchecks'>
            <label>
              <MinisterCheckbox name='deliberate_request' onChange={ this.props.updateAcknowledgement } checked={ this.props.acknowledgements.deliberate_request }/>
              <span className='checkbox_label'>
                "I confirm that I am at <strong>least 18 years of age</strong>, and that all the information that I have submitted is truthful and accurate to the best of my knowledge." <span className='required'>(Required)</span>
              </span>
            </label>
          </div>
          <div className='ordchecks'>
            <label>
              <MinisterCheckbox name='policy' onChange={ this.props.updateAcknowledgement } checked={ this.props.acknowledgements.policy }/>
              <span className='checkbox_label'>
                "I request to become an AMM Certified Minister. I undertake this request as a <strong>considered, deliberate, and responsible act</strong>." <span className='required'>(Required)</span>
              </span>
            </label>
          </div>
        </form>
      </div>
    );
  }
};

Beliefs.propTypes = {
  updateAcknowledgement: PropTypes.func.isRequired,
  acknowledgements: PropTypes.object.isRequired
};

export default Beliefs;
